import React from 'react';
import { useTranslation } from 'react-i18next';

import useGame from '../hooks/useGame';

const ScoreBoard = () => {

  const { t } = useTranslation();
  const { totalScore } = useGame();

  return (
    <div className="scoreboard">
      <div><span>{t('header.score')}:</span><span id="score-num">{totalScore}</span></div>
    </div>
  )
}

export default ScoreBoard;
